import { createTheme } from '@mui/material/styles';

import { FRESSNAPF_THEME } from '../theme';
import colors from '../tokens/colors';
import { fressnapfFontFamily } from '../tokens/fonts';
import typography from '../tokens/typography/fressnapf';

import baseTheme from './base.theme';

// base component styles
import { accordionFressnapf } from '../components/accordion.style';
import { autocompleteDaFressnapf } from '../components/autocomplete.style';
import { buttonFressnapf } from '../components/button.style';
import { checkboxFressnapf } from '../components/checkbox.style';
import { emailFressnapf } from '../components/email.style';
import { inputFressnapf } from '../components/input.style';
import { linkFressnapf } from '../components/link.style';
import { listFressnapf } from '../components/list.style';
import { phoneDaFressnapf } from '../components/phone.style';
import { radioFressnapf } from '../components/radio.style';
import { selectFressnapf } from '../components/select.style';
import { toggleSwitchFressnapf } from '../components/toggleSwitch.style';

// widget styles
import { backButtonFressnapf } from '../widgets/backButton.style';
import { formLabelFressnapf } from '../widgets/formLabel.style';
import { informationTextFressnapf } from '../widgets/informationText.style';
import { pageHeaderFressnapf } from '../widgets/pageHeader.style';
import { priceButtonFressnapf } from '../widgets/priceButton.style';

const theme = createTheme(baseTheme, {
  name: FRESSNAPF_THEME,
  palette: {
    background: {
      primary: colors.FRESSNAPF_BACKGROUND_TERTIARY,
      accordion: {
        header: colors.WHITE,
        body: colors.WHITE,
        footer: colors.WHITE,
      },
      button: colors.FRESSNAPF_PRIMARY,
      input: colors.WHITE,
      modalOverlay: colors.FRESSNAPF_BACKGROUND_TERTIARY,
      pageHeaderTitle: 'transparent',
      selectOption: colors.WHITE,
    },
    text: {
      primary: colors.FRESSNAPF_TEXT_PRIMARY,
      secondary: colors.FRESSNAPF_TEXT_SECONDARY,
      accent: colors.FRESSNAPF_YELLOWISH_GREEN_LIGHT,
      button: colors.WHITE,
      checkbox: colors.FRESSNAPF_TEXT_PRIMARY,
      input: colors.FRESSNAPF_TEXT_PRIMARY,
      label: colors.FRESSNAPF_TEXT_PRIMARY,
      placeholder: colors.FRESSNAPF_TEXT_PLACEHOLDER,
    },
    error: {
      main: colors.FRESSNAPF_TEXT_ERROR,
    },
    success: {
      main: colors.FRESSNAPF_PRIMARY_HOVER,
    },
  },
  shadows: [
    baseTheme.shadows[0],
    baseTheme.shadows[1],
    `0 0 4px 2px ${colors.FRESSNAPF_YELLOWISH_GREEN_LIGHT}`,
    `0 0 4px 2px ${colors.FRESSNAPF_YELLOWISH_GREEN_LIGHT}`,
    `0 0 4px 2px ${colors.FRESSNAPF_YELLOWISH_GREEN_LIGHT}`,
    baseTheme.shadows[5],
    baseTheme.shadows[6],
    baseTheme.shadows[7],
  ],
  typography: {
    fontFamily: fressnapfFontFamily,
    ...typography,
  },
  components: {
    accordion: accordionFressnapf,
    autocomplete: autocompleteDaFressnapf,
    button: buttonFressnapf,
    checkbox: checkboxFressnapf,
    email: emailFressnapf,
    input: inputFressnapf,
    link: linkFressnapf,
    list: listFressnapf,
    phone: phoneDaFressnapf,
    radio: radioFressnapf,
    select: selectFressnapf,
    toggleSwitch: toggleSwitchFressnapf,
  },
  widgets: {
    backButton: backButtonFressnapf,
    daDirektCode: {},
    formLabel: formLabelFressnapf,
    informationText: informationTextFressnapf,
    pageHeader: pageHeaderFressnapf,
    priceButton: priceButtonFressnapf,
  },
});

export default theme;
